module.exports = __webpack_public_path__ + "static/media/plaque_sapins_2023.f5a74f6f.png";